import React from "react";
import Swiper from "react-id-swiper";

class BLERemote extends React.Component {
  render() {
    const params = {
      effect: "coverflow",
      grabCursor: true,
      initialSlide: 2,
      centeredSlides: true,
      loop: true,
      spaceBetween: 0,
      slidesPerView: 4,
      pagination: {},
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1.43,
        slideShadows: false
      },
      autoplay: {
        delay: 5000
      },
      breakpoints: {
        360: {
          slidesPerView: 1,
          coverflowEffect: {
            depth: 50,
            modifier: 0
          }
        },
        640: {
          slidesPerView: 3,
          coverflowEffect: {
            depth: 80,
            modifier: 0
          }
        }
      }
    };

    return (
      <section id="ble-remote" className="theme-bg-ble-remote screenshots">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="section-title">
                <h2 className="text-white">BLE Remote</h2>
                <p className="text-white">(hired)</p>
                <img
                  src="https://cdn.johnbernazzani.com/white-line.svg"
                  alt="title-line"
                  className="img-fluid title-line"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <Swiper
                {...params}
                className="swiper-screenshots-container-1 swiper-container"
              >
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/ble-remote/4.png" alt="1" />
                </div>
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/ble-remote/5.png" alt="1" />
                </div>
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/ble-remote/1.png" alt="1" />
                </div>
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/ble-remote/3.png" alt="1" />
                </div>
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/ble-remote/2.png" alt="1" />
                </div>
              </Swiper>
            </div>
          </div>
          <div className="row m-0">
            <div className="col-12 text-center app-description">
              <h1>
                <i className="fa fa-mobile" />
              </h1>
              <p>
                A mobile app that pairs with a commercial LED light bar that
                allows for Bluetooth remote control of the unit. Users can
                intuitively adjust light color, intensity, and speed, and can
                save settings profiles for easy retrieval.
              </p>
            </div>
          </div>
          <div className="row crafted-with">
            <div className="col-12 text-center">
              <p className="text-white">Available Soon On</p>
            </div>
          </div>
          <div className="row tech-stack d-flex flex-row justify-content-center">
            <div className="app-store-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/app_store.png" alt="1" />
            </div>
            <div className="app-store-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/google_play.png" alt="1" />
            </div>
          </div>
          <div className="row crafted-with">
            <div className="col-12 text-center">
              <p>Crafted with</p>
            </div>
          </div>
          <div className="row tech-stack d-flex flex-row justify-content-center">
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/ionic.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/angular.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/bootstrap.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/bluetooth.png" alt="1" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default BLERemote;



// WEBPACK FOOTER //
// ./src/components/ble-remote.js